import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function POGenPublic() {
  const { token } = useParams();
  const [meta, setMeta] = useState(null);
  const [err, setErr] = useState("");
  const pdfUrl = `${API}/api/po-docs/public/${token}/pdf`;

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/api/po-docs/public/${token}`);
        setMeta(data);
      } catch (e) {
        setErr(e.response?.status === 404 ? "This share link has been revoked or is invalid." : "Unable to load PO");
      }
    })();
  }, [token]);

  if (err) return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F1EA] text-[#14181D] font-mono text-sm p-8">
      {err}
    </div>
  );
  if (!meta) return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F1EA] text-[#14181D] font-mono text-sm">Loading…</div>
  );

  return (
    <div className="min-h-screen bg-[#F5F1EA] p-6" style={{ color: "#14181D" }}>
      <div className="max-w-4xl mx-auto">
        <div className="mb-4 flex items-center justify-between">
          <div>
            <div style={{ fontSize: 10, letterSpacing: "0.25em", textTransform: "uppercase", color: "#8A6B3C", fontWeight: 700 }}>Explora ETrades Pvt Ltd</div>
            <div style={{ fontFamily: "Georgia, serif", fontSize: 28, marginTop: 4 }}>Purchase Order · {meta.po_no}</div>
            <div style={{ fontFamily: "monospace", fontSize: 11, color: "#5E6470", marginTop: 4 }}>
              {meta.buyer?.name} → {meta.supplier?.name} · {meta.po_date}
            </div>
          </div>
          <a href={pdfUrl} download={`${meta.po_no}.pdf`} data-testid="pogen-public-download"
            style={{ padding: "10px 18px", background: "#8A6B3C", color: "#F5F1EA", textDecoration: "none", fontFamily: "monospace", fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase" }}>
            Download PDF
          </a>
        </div>
        <iframe title="po-public" src={pdfUrl} className="w-full" style={{ height: "calc(100vh - 140px)", border: "1px solid #D8CFBF", background: "#fff" }} />
      </div>
    </div>
  );
}
